__turbopack_context__.v({
  "className": "_4_Nqrq_className",
  "variable": "_4_Nqrq_variable",
});
